// 플랜이 안 되는 교사가 출제 흐름을 체험해 볼 때 쓰는 값들.
// 실제 동작은 전부 서버가 정한다 (api/assignment/demo.py). 서버는 요청에 담긴 학생을
// 무시하고 그 교사의 체험용 학생(홍길동)으로 바꾼 뒤, 응답에 학습 링크를 실어 준다.

export const DEMO_STUDENT_NAME = "홍길동";

// 학생 선택 단계에 보여줄 홍길동. 서버가 이 값을 쓰지 않으므로 이름표일 뿐이다.
// id 는 실제 학생과 겹치지 않게 음수를 주고, level_list 는 목록 컴포넌트가 항상
// 읽으므로 빈 배열로 둔다.
export const DEMO_STUDENT_LIST = [
  { id: -1, name: DEMO_STUDENT_NAME, grade: 1, level_list: [] },
];

// 출제 직후 교사에게 보여줄 안내. 서버가 준 학생 링크를 그대로 쓴다.
export const buildDemoResultMessage = (worksheetTitle, demo) =>
  `${worksheetTitle} 과제를 ${demo?.student_name || DEMO_STUDENT_NAME} 학생에게 ` +
  `출제했습니다.\n\n` +
  `아래 주소가 학생이 받는 학습 링크입니다. 직접 풀어보시면 채점과 해설지까지 ` +
  `실제와 똑같이 동작합니다.\n\n` +
  `${demo?.student_url || ""}\n\n` +
  `체험용 학생이라 실제 재원생에게는 나가지 않았고 알림톡도 발송되지 않았습니다.`;
